import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-025dd5cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "taskmodal__dialog modal-dialog" }
const _hoisted_3 = {
  key: 0,
  class: "taskmodal__dialog__content modal-content border-0 rounded-1"
}
const _hoisted_4 = {
  key: 0,
  class: "taskmodal__dialog__content__header modal-header d-flex justify-content-center",
  role: "button"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "taskmodal__dialog__content__body modal-body" }
const _hoisted_7 = { class: "row mb-1" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "d-flex gap-2 justify-content-start align-items-start" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "taskmodal__dialog__content__body__icon bi bi-card-heading" }, null, -1))
const _hoisted_11 = { class: "taskmodal__dialog__content__body__title flex-grow-1" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "quiet ps-0" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" in list ")
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "taskmodal__dialog__content__body__members__labels d-flex flex-wrap gap-2 justify-content-start align-items-start my-4 ps-4" }
const _hoisted_18 = {
  key: 0,
  class: "taskmodal__dialog__content__body__title__members"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "Members", -1))
const _hoisted_20 = { class: "d-flex flex-wrap gap-1 align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }, null, -1))
const _hoisted_22 = {
  key: 1,
  class: "taskmodal__dialog__content__body__title__labels"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "Labels", -1))
const _hoisted_24 = { class: "d-flex flex-wrap gap-1 align-items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }, null, -1))
const _hoisted_26 = { class: "taskmodal__dialog__content__body__desc d-flex gap-2 justify-content-start align-items-start my-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-justify-left" }, null, -1))
const _hoisted_28 = { class: "w-100" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "taskmodal__dialog__content__body__desc__title" }, "Description", -1))
const _hoisted_30 = { class: "w-100" }
const _hoisted_31 = { class: "taskmodal__dialog__content__body__attachments d-flex gap-2 justify-content-start align-items-start my-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "taskmodal__dialog__content__body__attachments__icon bi bi-paperclip" }, null, -1))
const _hoisted_33 = { class: "w-100" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "taskmodal__dialog__content__body__attachments__title" }, "Attachments", -1))
const _hoisted_35 = { class: "taskmodal__dialog__content__body__activity my-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-2 justify-content-start align-items-start" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-ul" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-100 flex-grow-1" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "taskmodal__dialog__content__body__activity__title" }, "Activity")
  ])
], -1))
const _hoisted_37 = { class: "taskmodal__dialog__content__body__activity__comments__wrapper" }
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = { class: "taskmodal__dialog__content__body__actions d-flex flex-column gap-4 justify-content-between" }
const _hoisted_40 = { class: "taskmodal__dialog__content__body__actions__title" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Add to card ")
const _hoisted_42 = { class: "d-flex flex-column gap-2 justify-content-start align-items-start" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person" }, null, -1))
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Members ")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-tag" }, null, -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Labels ")
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-square" }, null, -1))
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Checklist ")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock" }, null, -1))
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Dates ")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1))
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Attachment ")
const _hoisted_53 = { class: "taskmodal__dialog__content__body__actions__title" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Actions ")
const _hoisted_55 = { class: "d-flex flex-column gap-2 justify-content-start align-items-start" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Move ")
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clipboard" }, null, -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Copy ")
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-image" }, null, -1))
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Make template ")
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye" }, null, -1))
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Watch ")
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-archive" }, null, -1))
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Archive ")
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-share" }, null, -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Share ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!
  const _component_action_button = _resolveComponent("action-button")!
  const _component_members_drop_down_content = _resolveComponent("members-drop-down-content")!
  const _component_workspace_dropdown = _resolveComponent("workspace-dropdown")!
  const _component_kanban_task_label = _resolveComponent("kanban-task-label")!
  const _component_label_drop_down_content = _resolveComponent("label-drop-down-content")!
  const _component_kanban_add_form = _resolveComponent("kanban-add-form")!
  const _component_kanban_task_attachment = _resolveComponent("kanban-task-attachment")!
  const _component_kanban_task_comment_input = _resolveComponent("kanban-task-comment-input")!
  const _component_kanban_task_comment = _resolveComponent("kanban-task-comment")!
  const _component_dates_drop_down_content = _resolveComponent("dates-drop-down-content")!
  const _component_attachment_drop_down_content = _resolveComponent("attachment-drop-down-content")!
  const _component_task_card_action_form = _resolveComponent("task-card-action-form")!
  const _component_copy_card_drop_down_content = _resolveComponent("copy-card-drop-down-content")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["taskmodal modal fade", { show: _ctx.show }]),
    id: `${_ctx.task.task[0]}${_ctx.task._id}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("i", {
              class: "bi bi-x taskmodal__dialog__content__close rounded-circle",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
              role: "button"
            }),
            (_ctx.cover)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: `${_ctx.$STATIC_URL}/${_ctx.cover.name}`,
                    class: "img-fluid w-50",
                    alt: "board"
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("section", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("input", {
                        ref: "taskNameInput",
                        value: _ctx.task.task,
                        type: "text",
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleTaskNameChange && _ctx.handleTaskNameChange(...args)), ["enter"])),
                        class: "form-control form-control-sm ps-0 py-0 d-block w-75 mb-1 shadow-none",
                        style: {"min-height":"auto"}
                      }, null, 40, _hoisted_12),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("u", null, _toDisplayString(_ctx.list.name), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("section", _hoisted_17, [
                    (_ctx.taskMembers.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskMembers, (mem) => {
                              return (_openBlock(), _createBlock(_component_avatar, {
                                key: mem._id,
                                name: mem.name
                              }, null, 8, ["name"]))
                            }), 128)),
                            _createVNode(_component_action_button, {
                              class: "taskmodal__dialog__content__body__title__members__add rounded-circle justify-content-center dropdown dropdown-toggle",
                              "data-bs-toggle": "dropdown",
                              "data-bs-auto-close": "false",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddMemberDD = !_ctx.showAddMemberDD))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_21
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_workspace_dropdown, {
                              title: "Members",
                              show: _ctx.showAddMemberDD,
                              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddMemberDD = false))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_members_drop_down_content, {
                                  "board-members": _ctx.currentBoard.members,
                                  "task-members": _ctx.task.members,
                                  onAddMember: _ctx.handleAddMemberToTask,
                                  onRemoveMember: _ctx.handleRemoveMemberFromTask
                                }, null, 8, ["board-members", "task-members", "onAddMember", "onRemoveMember"])
                              ]),
                              _: 1
                            }, 8, ["show"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.taskLabels.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskLabels, (label) => {
                              return (_openBlock(), _createBlock(_component_kanban_task_label, {
                                key: label._id,
                                text: label.text,
                                color: label.color
                              }, null, 8, ["text", "color"]))
                            }), 128)),
                            _createVNode(_component_action_button, {
                              class: "taskmodal__dialog__content__body__title__labels__add justify-content-center dropdown dropdown-toggle",
                              "data-bs-toggle": "dropdown",
                              "data-bs-auto-close": "false",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddLabelDD = !_ctx.showAddLabelDD))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_25
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_workspace_dropdown, {
                              title: "Labels",
                              show: _ctx.showAddLabelDD,
                              onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddLabelDD = false))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_label_drop_down_content, {
                                  "board-labels": _ctx.currentBoard.labels,
                                  "task-labels": _ctx.task.labels,
                                  onAddLabel: _ctx.handleAddLabelToTask,
                                  onRemoveLabel: _ctx.handleRemoveLabelFromTask
                                }, null, 8, ["board-labels", "task-labels", "onAddLabel", "onRemoveLabel"])
                              ]),
                              _: 1
                            }, 8, ["show"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("section", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, [
                        (!_ctx.showDescriptionBox)
                          ? (_openBlock(), _createBlock(_component_action_button, {
                              key: 0,
                              class: _normalizeClass(["taskmodal__dialog__content__body__desc__text p-2 w-100 pb-5 rounded-1", { 'bg-transparent': _ctx.task.description }]),
                              role: "button",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDescriptionBox = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.task.description || 'Add a more detailed description...'), 1)
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : (_openBlock(), _createBlock(_component_kanban_add_form, {
                              key: 1,
                              "default-value": _ctx.task.description,
                              "input-type": "textarea",
                              "button-text": "Save",
                              "button-classes": "btn-primary-2",
                              "text-area-placeholder": "Add a more detailed description...",
                              "show-sub-menu": true,
                              "text-area-styles": {
                        padding: '10px',
                        boxShadow: 'inset 0 0 0 2px var(--primary-clr-5)',
                        height: '120px'
                      },
                              onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDescriptionBox = false)),
                              onSubmit: _ctx.handleDescriptionChange
                            }, null, 8, ["default-value", "text-area-styles", "onSubmit"]))
                      ])
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.attachments, (attachment) => {
                        return (_openBlock(), _createBlock(_component_kanban_task_attachment, {
                          class: "my-2",
                          attachment: attachment,
                          key: attachment._id
                        }, null, 8, ["attachment"]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_kanban_task_comment_input, { onComment: _ctx.handleTaskComment }, null, 8, ["onComment"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.comments, (comment) => {
                        return (_openBlock(), _createBlock(_component_kanban_task_comment, {
                          comment: comment,
                          key: comment._id
                        }, null, 8, ["comment"]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_action_button, {
                          class: "w-100 dropdown dropdown-toggle",
                          "data-bs-toggle": "dropdown",
                          "data-bs-auto-close": "false",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showMembersDD = !_ctx.showMembersDD))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_43,
                            _hoisted_44
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_workspace_dropdown, {
                          title: 'Members',
                          show: _ctx.showMembersDD,
                          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showMembersDD = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_members_drop_down_content, {
                              "board-members": _ctx.currentBoard.members,
                              "task-members": _ctx.task.members,
                              onAddMember: _ctx.handleAddMemberToTask,
                              onRemoveMember: _ctx.handleRemoveMemberFromTask
                            }, null, 8, ["board-members", "task-members", "onAddMember", "onRemoveMember"])
                          ]),
                          _: 1
                        }, 8, ["show"]),
                        _createVNode(_component_action_button, {
                          class: "w-100 dropdown dropdown-toggle",
                          "data-bs-toggle": "dropdown",
                          "data-bs-auto-close": "false",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showLabelsDD = !_ctx.showLabelsDD))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_45,
                            _hoisted_46
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_workspace_dropdown, {
                          title: 'Labels',
                          show: _ctx.showLabelsDD,
                          onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showLabelsDD = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_label_drop_down_content, {
                              "board-labels": _ctx.currentBoard.labels,
                              "task-labels": _ctx.task.labels,
                              onAddLabel: _ctx.handleAddLabelToTask,
                              onRemoveLabel: _ctx.handleRemoveLabelFromTask
                            }, null, 8, ["board-labels", "task-labels", "onAddLabel", "onRemoveLabel"])
                          ]),
                          _: 1
                        }, 8, ["show"]),
                        _createVNode(_component_action_button, {
                          class: "w-100",
                          disabled: ""
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_47
                          ]),
                          default: _withCtx(() => [
                            _hoisted_48
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_action_button, {
                          class: "w-100 dropdown dropdown-toggle",
                          "data-bs-toggle": "dropdown",
                          "data-bs-auto-close": "false",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDateDD = !_ctx.showDateDD))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_49
                          ]),
                          default: _withCtx(() => [
                            _hoisted_50
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_workspace_dropdown, {
                          title: 'Dates',
                          show: _ctx.showDateDD,
                          onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showDateDD = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_dates_drop_down_content, {
                              date: _ctx.task.date,
                              onDateChange: _ctx.handleDateChange
                            }, null, 8, ["date", "onDateChange"])
                          ]),
                          _: 1
                        }, 8, ["show"]),
                        _createVNode(_component_action_button, {
                          class: "w-100 dropdown dropdown-toggle",
                          "data-bs-toggle": "dropdown",
                          "data-bs-auto-close": "false",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showAttachmentDD = !_ctx.showAttachmentDD))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_51
                          ]),
                          default: _withCtx(() => [
                            _hoisted_52
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_workspace_dropdown, {
                          id: "attachment-dropdown",
                          title: 'Attach from...',
                          class: "p-0 mb-2",
                          "header-classes": "px-2",
                          "divider-classes": "mx-2",
                          show: _ctx.showAttachmentDD,
                          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showAttachmentDD = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_attachment_drop_down_content, {
                              onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showAttachmentDD = false))
                            })
                          ]),
                          _: 1
                        }, 8, ["title", "show"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_action_button, {
                          class: "w-100 dropdown dropdown-toggle",
                          "data-bs-toggle": "dropdown",
                          "data-bs-auto-close": "false",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showMoveDD = !_ctx.showMoveDD))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_56
                          ]),
                          default: _withCtx(() => [
                            _hoisted_57
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_workspace_dropdown, {
                          title: 'Move card',
                          show: _ctx.showMoveDD,
                          onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showMoveDD = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_task_card_action_form, {
                              title: "Select destination",
                              "submit-text": "Move",
                              onSubmit: _ctx.handleMoveTask
                            }, null, 8, ["onSubmit"])
                          ]),
                          _: 1
                        }, 8, ["show"]),
                        _createVNode(_component_action_button, {
                          class: "w-100 dropdown dropdown-toggle",
                          "data-bs-toggle": "dropdown",
                          "data-bs-auto-close": "false",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showCopyDD = !_ctx.showCopyDD))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_58
                          ]),
                          default: _withCtx(() => [
                            _hoisted_59
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_workspace_dropdown, {
                          title: 'Copy card',
                          show: _ctx.showCopyDD,
                          onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showCopyDD = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_copy_card_drop_down_content, {
                              onClose: _cache[20] || (_cache[20] = ($event: any) => {;(_ctx.showCopyDD = false), _ctx.$emit('close')})
                            })
                          ]),
                          _: 1
                        }, 8, ["show"]),
                        _createVNode(_component_action_button, {
                          class: "w-100",
                          disabled: ""
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_60
                          ]),
                          default: _withCtx(() => [
                            _hoisted_61
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_action_button, {
                          class: "w-100",
                          disabled: ""
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_62
                          ]),
                          default: _withCtx(() => [
                            _hoisted_63
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_action_button, {
                          class: "w-100",
                          disabled: ""
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_64
                          ]),
                          default: _withCtx(() => [
                            _hoisted_65
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_action_button, {
                          class: "w-100",
                          disabled: ""
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_66
                          ]),
                          default: _withCtx(() => [
                            _hoisted_67
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}